import { Component, Input } from '@angular/core';
import { RequestCriteria } from '../../model/request-criteria';

@Component({
  selector: 'app-filters-view',
  templateUrl: './filters-view.component.html',
  styleUrls: ['./filters-view.component.scss']
})
export class FiltersViewComponent {
  @Input()
  filters: RequestCriteria;
}
